import { useAtomValue } from 'jotai';

import { useTranslate } from '@growtherapy/i18n';

import { ChatDrawerControlMenuItem } from '../../../session/controls/ChatDrawerControl';
import { ChatDrawerButtonWrapper as ChatDrawerButton } from '../../chat/ChatDrawerButton';
import { useChatDrawerButtonUtils } from '../../chat/useChatDrawerButtonUtils';
import { MEETING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID } from '../../constants';
import { VisitorDrawerState, visitorDrawerStateAtom } from '../../state';

export function VisitorMeetingChatDrawerButton() {
  const t = useTranslate();
  return (
    <ChatDrawerButton
      defaultTitle={t('telehealth-core:meta.meetingRoom')}
      drawerId={MEETING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID}
    />
  );
}

export function VisitorMeetingChatDrawerMenuItemWrapper() {
  const drawerState = useAtomValue(visitorDrawerStateAtom);
  const { unreadMessagesCount, toggleChatDrawer, isChatDrawerDisabled } = useChatDrawerButtonUtils();

  return (
    <ChatDrawerControlMenuItem
      drawerId={MEETING_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID}
      isChatDrawerOpen={drawerState === VisitorDrawerState.CHAT}
      onClickChatButton={toggleChatDrawer}
      isChatButtonDisabled={isChatDrawerDisabled}
      unreadMessageCount={unreadMessagesCount}
    />
  );
}
